<template>
  <div id="addEditState">
    <v-form ref="stateForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="State" @blur="checkDuplicates" v-model.trim="newState.name" :rules="formRules.state" class="required pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
               <v-flex class="xs12 sm6 full">
                <v-autocomplete
                    label="Country" 
                    :items="countryList"
                    @keyup.enter="searchCountry($event)"
                    id="recipientSearch"
                    item-text="name"
                    item-value="id"
                    height="30px"
                    v-model="newState.country"
                    hide-no-data
                    hint="Type atleast 3 characters to search"
                    class="required pr-4 pl-4"
                    @input="changedData"
                    :rules="formRules.country">
                    <v-icon slot="append" @click="searchCountry($event)"> search </v-icon>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session store */
import swal from 'sweetalert2';
import { getCollection, create } from '../../helpers/helpers';
import Vue from 'vue';
export default {
  data: () => ({
    newState: {
      name: '',
      country: '',
    },
    countryList: [],
    searchString: '',
    selectedData: false,
    formRules: {
      state: [v => !!v.trim() || 'State is required'],
      country: [v => !!v || 'Country is required']
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Country: {
      set (value) {
        store.commit('setCountry', value);
      },
      get () {
        return store.state.Country;
      }
    },
    State: {
      set (value) {
        store.commit('setState', value);
      },
      get () {
        return store.state.State;
      }
    }
  },
  created () {
    this.feedSelects('Country');
    this.feedSelects('State');
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    searchCountry (e) {
      this.countryList = [];
      this.searchString = e.target.value ? e.target.value : document.querySelector('input[id="recipientSearch"]').value;
      if (this.searchString && this.searchString.length > 2) {
        let filteredList = this.Country.filter((element) => {
          if (element.name.toLowerCase().includes(this.searchString.toLowerCase())) {
            return element;
          }
          return false;
        });
        this.countryList = [...filteredList];
      }
    },
    async feedSelects (entity) {
      if (!this[entity].length) {
        let { data, total, error } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          this[entity] = data;
        }
      }
    },
    backToListing () {
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/states' });
    },
    changedData () {
      this.selectedData = true;
    },
    async save () {
      if (this.$refs.stateForm.validate()) {
        this.selectedData = false;
        let { error, data, status } = await create('State', this.newState);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.State.push(data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'State created successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              window.getApp.$emit('pageSubHeader', '');
              this.$router.push({ path: '/states' });
            }
          });
        }
      }
    },
    checkDuplicates () {
      let duplicateValue;
      if (this.newState.name) {
        duplicateValue = this.State.find(state => state.name.toLowerCase() === this.newState.name.toLowerCase());
      }
      if (duplicateValue) {
        swal.fire({
          type: 'error',
          title: `${this.newState.name} is already available`,
          text: 'Duplicate state name',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        this.newState.name = '';
        return;
      }
    }
  }

};
</script>


// WEBPACK FOOTER //
// src/pages/States/add.vue